module.exports = __webpack_public_path__ + "static/media/IMG_1651-min.3947f728.jpg";